export default {
  account: 'Tài khoản',
  password: 'Mật khẩu',
  rePassword: 'Mật khẩu xác nhận',
  organizationName: 'Tên tổ chức',
  job:'Công việc ngành nghề',
  city: 'Tỉnh/Thành phố',
  district: 'Quận/Huyện',
  subDistrict: 'Xã/Phuờng',
  houseNumber: 'Số nhà',
  fullAddress: 'Địa chỉ',
  zipCode: 'Zip Code',
  adminAccount: 'Tài khoản admin',
  phoneNumber: 'Số điện thoại',
  organizationType: 'Loại tổ chức',
  expiredDate: 'Thời gian hết hạn',
  streamUrl: 'Link stream',
  firstName: 'Họ',
  lastName: 'Tên',
  birthday: 'Ngày sinh',
  email: 'Email',
  fullName: 'Tên đầy đủ',
  gender: 'Giới tính',
  activeStatus: 'Trạng thái hoạt động',
  functionName: 'Tên chức năng',
  functionAlias: 'Tên hiển thị',
  functionApiPrefix: 'API Path',
  functionScreenPrefix: 'Screen Path',
  metadata: 'Thông tin bổ sung',
  businessPackage: 'Tên gói dịch vụ',
  totalKeyword: 'Số lượng từ khóa',
  totalData: 'Số lượng dữ liệu',
  totalSubAccount: 'Số lượng tài khoản phụ',
  totalDays: 'Số ngày',
  price: 'Giá',
  displayOrder: 'Thứ tự hiển thị',
  topicName: 'Tên chủ đề',
  topicGroupName : 'Tên dự án',
  homeTown:'Địa chỉ thường trú',
  priority:'Mức độ ưu tiên',
  groups:'Nhóm',
  relationship:'Mối quan hệ',
  type:'Loại hình',
  url:'Đường link',
  keyword: 'Từ khóa',
  name: "Tên báo cáo",
  facebookId: "Facebook Id",
  link: "Đường dẫn",
  article:'Nguồn tin',
  warning: 'Nội dung thông báo',
  website: 'Tên website',
  time: 'Thời gian',
  keywordDependent:'Từ khóa phụ',
  businessTarget:'Lĩnh vực của bạn',
  oldPassword: "Mật khẩu cũ",
  urlFacebook:'Nguồn Facebook',
  urlWebsite:'Nguồn Website',
  formality:'Hình thức',
  description: 'Mô tả',
  project: 'Dự án',
  topic: 'Chủ đề',
  conditionProject: 'Điều kiện dự án',
  condition: 'Điều kiện',
  source: 'Nguồn',
  typesReport: 'Loại báo cáo',
  timeReport : 'Thời điểm',
  dataRangeError : 'Phạm vi dữ liệu:',
  title : 'Tiêu đề',
  workingParts : 'Bộ phận',
  inDusTry : 'Ngành nghề',
  uses : 'Mục đích sử dụng',
  cateLink: 'Link category',
  authorXpath: 'Author Xpath',
  contentParentXpath: 'Content Xpath',
  descriptionXpath: 'Description Xpath',
  imageXpath: 'Image Xpath',
  linkDomain: 'Link Domain',
  linksXpath: 'Link Xpath',
  nameDomain: 'Domain',
  textXpath: 'Content Xpath',
  timeRegex: 'Time Regex',
  timeXpath: 'Time Xpath',
  titleXpath: 'TItle Xpath',
  deleteConfirmation: 'Bạn có chắc chắn xóa bản ghi?',
  textSuccess: 'Xóa thành công',
  textError: 'Xóa thất bại',
  btnAdd: 'Thêm mới',
  siteMap: 'Site map',
  rss: 'RSS',
}
